var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cursor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cursor_2",
    d: "M14.1076 2.28868L18.6662 18.2802C18.9016 19.1059 18.044 19.819 17.2642 19.4459L2.16146 12.2208C1.35844 11.8367 1.41879 10.6841 2.25748 10.3869L4.62353 9.5486C7.33055 8.58946 9.60075 6.70199 11.0241 4.2271L12.2682 2.06393C12.7092 1.29715 13.8653 1.43841 14.1076 2.28868Z",
    fill: "#9747FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCursor);
export default __webpack_public_path__ + "static/media/purple-cursor.2442def355f2c4ce33f2c6be7dd82ed0.svg";
export { ForwardRef as ReactComponent };